import React from 'react'

import Card from '../../components/card/card'
import './section2.css'
import "react-responsive-carousel/lib/styles/carousel.css";
import { Carousel } from 'react-responsive-carousel';

import Consulter from '../../assets/icons/consulter.png'
import Abap from '../../assets/icons/abap.png'
import Fiori from '../../assets/icons/fiori.png'
import Bi from '../../assets/icons/businessBI.png'
import Integracao from '../../assets/icons/integracao.png'
import Analise from '../../assets/icons/analise.png'
import Web from '../../assets/icons/web.png'
import Mobile from '../../assets/icons/mobile.png'
import Desktop from '../../assets/icons/desktop.png'


export default function Section2() {
    return (
        <div id="section2" className="container-fluid">
            <div className="container">
                <div className="row">
                    <div className="col-12 text-center section-header">
                        <label className="tituloSection d-flex justify-content-center">Conheça nossos serviços e produtos</label>
                        <label className="subTituloSection mt-2">A solução certa para o seu negócio</label>
                    </div>
                </div>

                <div className="row justify-content-center d-md-flex d-none">
                    <div className="col-12">
                        <div className="card-area-grid">
                            <Card img={Consulter} titulo="Consultoria SAP" text="Projetos em múltiplos módulos SAP com consultores especializados e suporte dedicado." />
                            <Card img={Abap} titulo="Desenvolvimento ABAP" text="Soluções customizadas para o SAP: relatórios ALV, BAPIs, user exits e muito mais." />
                            <Card img={Fiori} titulo="Aplicativos SAP Fiori" text="Aplicações SAP modernas e responsivas, acessíveis em qualquer dispositivo." />
                            <Card img={Bi} titulo="Business Intelligence" text="Dashboards em PowerBI, análise de dados e pipelines ETL para decisões estratégicas." />
                            <Card img={Integracao} titulo="Integração de Sistemas" text="Conectamos sistemas legados a tecnologias modernas com segurança e zero perda de dados." />
                            <Card img={Analise} titulo="Análise de Processos" text="Mapeamos e otimizamos seus processos internos, eliminando retrabalho e ineficiências." />
                            <Card img={Web} titulo="Sites e Sistemas Web" text="Plataformas web modernas com foco em performance, UX e design profissional." />
                            <Card img={Mobile} titulo="Aplicativos Mobile" text="Apps nativos e híbridos leves, funcionais e integrados ao seu ecossistema de TI." />
                            <Card img={Desktop} titulo="Softwares para Desktop" text="Aplicações instaláveis seguras e robustas, aproveitando todo o poder da máquina." />
                        </div>
                    </div>
                </div>

                <div className="row justify-content-center d-md-none d-flex">
                    <div className="col-12">
                        <Carousel
                            showThumbs={false}
                            interval={6000}
                            swipeScrollTolerance={100}
                            autoPlay={true}
                            showArrows={false}
                            infiniteLoop={true}
                            emulateTouch={true}
                            showIndicators={true}
                            statusFormatter={(current, total) => `${current} / ${total}`}
                        >
                            <div className="card-area-slider">
                                <Card img={Consulter} titulo="Consultoria SAP" text="Projetos SAP com consultores certificados e suporte dedicado." />
                                <Card img={Abap} titulo="Desenvolvimento ABAP" text="Soluções customizadas no SAP com a linguagem ABAP." />
                                <Card img={Fiori} titulo="Aplicativos SAP Fiori" text="Apps SAP modernos em qualquer dispositivo." />
                            </div>
                            <div className="card-area-slider">
                                <Card img={Bi} titulo="Business Intelligence" text="Dashboards em PowerBI e soluções ETL." />
                                <Card img={Integracao} titulo="Integração de Sistemas" text="Conectamos sistemas legados com tecnologia moderna." />
                                <Card img={Analise} titulo="Análise de Processos" text="Otimize processos e elimine retrabalho." />
                            </div>
                            <div className="card-area-slider">
                                <Card img={Web} titulo="Sites e Sistemas Web" text="Plataformas modernas com performance e design." />
                                <Card img={Mobile} titulo="Aplicativos Mobile" text="Apps leves e integrados ao seu sistema de gestão." />
                                <Card img={Desktop} titulo="Softwares Desktop" text="Aplicações robustas e seguras para Windows." />
                            </div>
                        </Carousel>
                    </div>
                </div>
            </div>
        </div>
    )
}
